// @flow
import apiFetch from 'api/fetch';

export function logout(token: string) {
  return apiFetch('/logout', {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
  });
}



// WEBPACK FOOTER //
// ./src/pages/logout/logoutApi.js